module.exports = __webpack_public_path__ + "img/resource_mask1.6cb5efb3.png";